<template>
  <div>
    <h2 class="dantai-title pc_only" style="background: rgb(255 156 51);color:white"><slot>タイトル</slot></h2>
  </div>
    <span class="sp_only">
      <span class="sp-title" style="color:#FFF;background: rgb(255, 132, 0);">
        <slot>タイトル</slot>
          <input type="text" class="form-control form-select" v-if="GlobalData.user_name && family_flg" v-bind:value="GlobalData.user_name" v-on:click="multipleusers_change" readonly="readonly">
          <input type="text" class="form-control" v-else-if="GlobalData.user_name" v-bind:value="GlobalData.user_name" readonly="readonly">
          <input type="text" class="form-control" v-else-if="GlobalData.$profile" value="未登録" readonly="readonly">
          <input type="text" class="form-control" v-else value="----------------------------------------------------------------------------------" readonly="readonly">
      </span>
      
    <!-- 新規登録・ログインボタン（スマホのみ） -->
     <template v-if="login_status == false"  >
        <div class="sp_button_area" v-if="login_status == false" style="text-align:center;padding-bottom:10px;
          flex-direction: row;
            justify-content: center;">
          <button class="btn btn-primary mx-aut" style="font-size: 13.5px;width: 200px; height: 40px;margin:0 5px 10px 5px;padding: 0;background-color: #F5F5F5;color:#000;border:1px solid #000" v-on:click="user_signin()">新規登録</button>
          <br>
          <button class="btn btn-primary mx-aut" style="font-size: 13.5px;width: 200px; height: 40px;margin:0 5px 10px 5px;padding: 0;background-color: #F5F5F5;color:#000;border:1px solid #000" v-on:click="login()">ログイン</button>

        </div>

          <b style="margin-bottom:10px">※事前説明会の申込みにはログインが必要です。</b>
          
      <br>
      <br>
     </template>
   <div class="sp_button_area" style="text-align:center;padding-bottom:10px;
      flex-direction: row;
        justify-content: center;">
     <button class="btn btn-primary mx-aut" 
     style="font-size: 13.5px;width: 200px; height: 40px;margin:0 5px 10px 5px;padding: 0;background-color: #06f;color:white;border:1px solid #000" 
     v-on:click="return_program()">体験プログラム一覧</button>
   
       </div>
    
    <div id="manual_area">

    <span v-on:click="manual_open"><img class="m_icon" src="../../images/mark/manual.png"  />事前説明会のマニュアル</span>
    <span v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png" style="height:35px" /></span>

    </div>

    <br clear="all">
    <div style="text-align:center;padding: 5px;text-align: left;font-size: 0.9rem;">
      <span style="color:red">名称をタップしてください。</span><br>
      （<span style="color:#FF8400">オレンジ枠下線部</span>）
     </div>
    </span>
  <div class="p-2 " style="margin-top:0;background-color:white">
  
    <div v-if="midoku_count!=0" class="pc_only" style="color:red;cursor: pointer;" :onclick="move_notification">
      <u>
        未読のお知らせが {{midoku_count}} 件あります。
      </u>
     </div>

    <!-- パンくずリスト -->
     <span class="pc_only">
    <nav  style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" v-on:click="home" style="cursor:pointer">Home</li>{{ev}}
        <li class="breadcrumb-item active" aria-current="page"><slot>タイトル</slot></li>
      </ol>
    </nav>
    
    <div id="manual_area" >

    <span v-on:click="manual_open"><img class="m_icon" src="../../images/mark/manual.png"  />事前説明会のマニュアル</span>
    <span  v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png"  />システムQ&A</span>

    </div>

    <br clear="all"></span>
    <!-- PC時は全件数、ページ選択、表示件数を表示 -->
  <div class="pg_list_page" style="padding: 0 5px;">

    <div style="width:25%">
      <span style="display:flex;align-items: center;"><b style="font-size: 20px;padding-right: 5px">{{ kensu }}</b> 件見つかりました</span>
    </div>

    <div style="width:50%;display: flex;justify-content: center;align-items: center;margin:0 auto">
        <div style="float:left;cursor:pointer" v-on:click="top">最初へ&nbsp;&nbsp;</div>
        <div style="float:left;cursor:pointer" v-on:click="back">前へ&nbsp;&nbsp;</div>
        <div v-for="i in tm" :key="i" style="float:left;cursor:pointer" v-on:click="page(i)">&nbsp;{{i}}&nbsp;</div>
        <div style="float:left;cursor:pointer" v-on:click="forward">&nbsp;&nbsp;次へ</div>
        <div style="float:left;cursor:pointer" v-on:click="last">&nbsp;&nbsp;最後へ</div>
    </div>
    
    <div style="width:25%;display: flex;align-items: center;justify-content: flex-end;">
      
      <span style="display:flex;float: right;">
        表示件数：
        <select v-model="gyo_count" v-on:change="gyo_change">
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="30">30</option>
          <option value="40">40</option>
          <option value="50">50</option>
        </select>
      </span>
    </div>
  </div>

    
  <!--スマホ時は件数のみ表示-->
  <div class="sp_only" style="width:100%;padding-left:5px;">
      <span style="display:flex;align-items: center;">検索結果 <b style="padding:0 10px">{{ kensu }}</b> 件</span>
  </div>
    <!-- 事前説明会概要 -->
    <div align="left" v-for="(pg,i) in program.slice(st-1,ed)" v-bind:key="pg.id">
    <div v-bind:class="{'hov':over(i) == false,'hov_over':over(i) == true}" style="padding:4px;margin-bottom: 12px;">
    <table id="jizen_list" border="1" rules="all"  style="width:100%;border-collapse:collapse;" v-if="pg.syurui != 4 && pg.syurui != 5">
      <tr v-on:click="shosai(i)">
        <td style="font-size:16px;background-color:white;display:flex;align-items: center;justify-content: space-between;">
          <div style="float:left"><b>{{ syurui_list[pg.syurui] }}</b><br>
           
          </div>

          <!-- 種類が動画視聴以外の時のみ満員をチェック -->
          <template v-if="pg.syurui != 3">
            <div v-if="pg.jisseki_count >= pg.teiin" style="float:right" >
              
            <img  src="../../images/max2.png" alt="満員御礼" style="height:45px" />
            </div>
          </template>
        </td>
      </tr>
      
      <tr v-on:click="shosai(i)">
        <td style="padding:2pt 6pt;background-color:#FF8400;color:white;border-bottom: 1px solid #FFF;display: flex;justify-content: flex-start;align-items: center;">
          <div style="font-size:20px;"><u>{{pg.jizen_name }}</u></div>
        </td>
      </tr>
      <tr v-on:click="shosai(i)"  v-if="pg.shimekiri_date">
        
        <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
          
          <div style="display: flex;align-items: center;">
            <b><div>〆切日</div></b>
            <div class="program_naiyo">{{DateSetting(pg.shimekiri_date)}}</div>
          </div>
        </td>
    
      </tr>
      <tr v-on:click="shosai(i)"  v-if="pg.syurui != 3">
        
        <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
          <div style="display: flex;align-items: center;">
            <b><div>開催日</div></b>
            
            <div class="program_naiyo">
              <template v-if="pg.syurui == 3">
                  <template v-if="pg.movie_start_date && pg.kensyu_date">
                    <!--両方とも入力-->
                    {{ DateSetting(pg.movie_start_date) }} ～ {{ DateSetting(pg.kensyu_date) }}
                  </template>
                  <template v-else-if="!pg.movie_start_date && pg.kensyu_date">
                    <!--至のみ入力-->
                    {{ DateSetting(pg.kensyu_date) }} まで
                  </template>
                  <template v-else-if="pg.movie_start_date && !pg.kensyu_date">
                    <!--自のみ入力-->
                    {{ DateSetting(pg.movie_start_date) }} 以降
                  </template>
                  <template v-else>
                     ー
                  </template> 
                </template>
                <template v-else>
                  <template v-if="pg.kensyu_date">
                    {{ DateSetting(pg.kensyu_date) }}
                  </template>
                  <template v-else>
                     ー
                  </template> 
                  &nbsp;
                  {{ TimeSetting(pg.jikantai_start) }}
                  <template v-if="pg.jikantai_end">
                  &nbsp;～&nbsp;
                  {{ TimeSetting(pg.jikantai_end) }}
                  </template>
                </template>
            </div>
          </div>
        </td>
    
      </tr>
      
      <tr v-on:click="shosai(i)"  v-if="pg.syurui != 3 && pg.basyo">
        
        <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
          <div style="display: flex;align-items: center;" >
            <b><div>場所</div></b>
            
            
            <div class="program_naiyo">{{pg.basyo}}</div>
          </div>
        </td>
    
      </tr>
      <tr v-on:click="shosai(i)" v-if="pg.syurui != 3 && pg.teiin" >
        
        <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
          
          <div style="display: flex;align-items: center;" >
            <b><div>定員</div></b>
            <div class="program_naiyo">{{pg.teiin}} 人</div>
          </div>
        </td>
    
      </tr>
      <tr v-on:click="shosai(i)" v-if="pg.syurui != 3 && pg.taikenkaishi_date" >
        
        <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
          
          <div style="display: flex;align-items: center;">
            <b><div>開始日</div></b>
            <div class="program_naiyo">{{DateSetting(pg.taikenkaishi_date)}}</div>
          </div>
        </td>
    
      </tr>
      <tr v-on:click="shosai(i)" v-if="pg.bikou1" >
        
        <td style="font-size:16px;padding:1pt 6pt;background-color:linen;" border="1">
          
          <div style="display: flex;align-items: center;" >
            <b><div>特記事項</div></b>
            
            <div class="program_naiyo">{{pg.bikou1}} </div>
          </div>
        </td>
    
      </tr>
    </table>
  </div>
    </div><br/>
    
    <div class="pg_list_page" style="width:100%;justify-content: center;margin:0 auto">
        <div style="float:left;cursor:pointer" v-on:click="top">最初へ&nbsp;&nbsp;</div>
        <div style="float:left;cursor:pointer" v-on:click="back">前へ&nbsp;&nbsp;</div>
        <div v-for="i in tm" :key="i" style="float:left;cursor:pointer" v-on:click="page(i)">&nbsp;{{i}}&nbsp;</div>
        <div style="float:left;cursor:pointer" v-on:click="forward">&nbsp;&nbsp;次へ</div>
        <div style="float:left;cursor:pointer" v-on:click="last">&nbsp;&nbsp;最後へ</div>
    </div><br/>
  </div>
     
      <!--メッセージを表示するモーダルウィンドウ-->
      <component v-bind:is="contentMessage"
                v-bind:message_text="message"
                v-bind:message_cat="message_cat"
                v-bind:message_flag="message_flag"
                @close_message="Close_message"
                @ok_message="OK_message"/>

            
</template>

<script setup>
/* eslint-disable */ 
import { useRouter,useRoute } from 'vue-router'
import { DateSetting,TimeSetting,DateTimeSetting,GlobalData,EuShimekiriSetting } from '../js/userdata.js'

import axios from 'axios'
import { ref, computed } from 'vue';
/* メッセージを表示するモーダルウィンドウ */
import MessageModal from '../common/MessageModal.vue'  

let message = ref("")//表示するメッセージ
let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
let message_flag = ref(false)//表示・非表示フラグ

/* 表示する子コンポーネント関係の情報 */
const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
contentMessage.value = null // 表示する子コンポーネント

import { useStore } from 'vuex'
const store = useStore()
let current_page = ref(store.state.current_page)

//const fileInput = ref(null);
const router = useRouter()
const route = useRoute()

const prop = defineProps(['param'])
let program = prop.param.program
console.log(program)
const cityname = prop.param.cityname

const midoku_count = ref(prop.param.midoku_count)

// ユーザーが本来所属する社協の名前
let shozoku_name = ref(prop.param.shozoku_name)

// 事前説明会表示件数の取得
let kensu = ref(0)
const emit = defineEmits(['call'])

// ログイン状態
let login_status = ref(true)

  // 曜日配列
  // const youbi_list = ["日","月","火","水","木","金","土"]

  // 事前説明会の種類配列
  const syurui_list = ["（未設定）","対面","オンライン","動画視聴","特殊"]

  // 申込む事前説明会
  let moshikomi_pg = {}

    // 社協名と受付〆切日を取得
  let shakyo_name = ""
  let end_flg = false

    axios.post(GlobalData.$API_URL+"Shakyo_read", 
            {shakyo:route.params.shakyo}
            ).then(response => {
           

              // 社協名を取得
              shakyo_name = response["data"].shakyo_name

        })
        .catch(error => {
          
//            alert("社協情報の取得時にエラーが発生しました。"+error)
        })
    

// 表示件数
const gyo_count = ref(store.state.gyo_count)

// スマホの時は１ページ目かつ全件（10000）
if (document.getElementById("app").clientWidth < 962) {
  
  current_page.value = 1
  gyo_count.value = 10000
}

// 表示件数を変えたら保持
const gyo_change = ()  => {
  store.state.gyo_count = gyo_count.value

  // 1ページ目に戻す
  top()
}

const st = ref(1)

let family_flg = ref(false)  // 家族フラグ(家族の登録が出来る)が設定されている時は、右メニューのボタンが表示される

let family_flg_get_error = 0
const family_flg_get = () => {
    let res = null
    axios.post(GlobalData.$API_URL+"TaikenAccountUser_read", {taikenuser_id:GlobalData.user_id})
    .then(response => {
        
        if(response.data.accountuser){
            res = response.data.accountuser
            family_flg.value = res['family']

        } else {
            family_flg.value = false
        }
    })
    .catch(error => {
        if(family_flg_get_error == 6){
            alert(error + GlobalData.$axios_error)
        }else{
            family_flg_get_error++
            setTimeout(function(){family_flg_get()},"1000")
        }
        
    })
}

family_flg_get()

let ed = ref(Math.min(parseInt(gyo_count.value), program.length+1))
const tm = computed(() => {
    st.value = 1
    ed.value = Math.min(parseInt(gyo_count.value), program.length+1);
    return Math.ceil(program.length / parseInt(gyo_count.value));
})
//-------- ページネーション -------------------
const top     = ()  => { st.value = 1
                         ed.value = st.value+parseInt(gyo_count.value)-1
                         current_page.value = 1
                         page_change(1)                         
                         emit('call',{ cmd:'page_scroll' }) }
const back    = ()  => { st.value = Math.max(1,st.value-parseInt(gyo_count.value))
                         ed.value = st.value+parseInt(gyo_count.value)-1 
                        let set_page = current_page.value
                        // 現在ページ数から1引いたら0にならない場合はマイナスする
                        if( (set_page-1 ) != 0){
                          set_page = set_page - 1
                        }
                         page_change(set_page)
                         emit('call',{ cmd:'page_scroll' })}
const page    = (i) => { st.value = (i-1)*parseInt(gyo_count.value)+1;
                         ed.value = Math.min(i*parseInt(gyo_count.value), program.length+1);
                         page_change(i)
                         emit('call',{ cmd:'page_scroll' })}
const forward = ()  => { st.value += parseInt(gyo_count.value);

                         let set_page = current_page.value

                         // 加算後の表示件数が全件数を超える場合は減算して戻す
                         if (st.value > program.length) { 
                          st.value -= parseInt(gyo_count.value)
                         }else{
                          // 加算後の表示件数が全件数を超えない場合はページを加算する
                          set_page = set_page + 1
                         }
                         ed.value = Math.min( st.value+parseInt(gyo_count.value)-1, program.length) 
                         page_change(set_page)
                         emit('call',{ cmd:'page_scroll' })}
const last    = ()  => { st.value = Math.max(1,program.length-parseInt(gyo_count.value)+1)
                         ed.value = Math.min(st.value+parseInt(gyo_count.value), program.length) 
                         // 全件数 / 表示件数を切り上げたものが最後のページ
                         page_change(Math.ceil(program.length / parseInt(gyo_count.value)))
                         emit('call',{ cmd:'page_scroll' })}
setTimeout(function(){ page(current_page.value) }, "100");

let page_change = function(page){
  current_page.value = page
  store.state.current_page = page
}

//------------------- 締切日を過ぎていれば非表示
const over = (i) => {
    let today = new Date()

    if(program[i+st.value-1].shimekiri_date == "" || program[i+st.value-1].shimekiri_date == null){
      return false
    }

    let shimekiri = new Date(program[i+st.value-1].shimekiri_date +" 23:59:59")

    if (shimekiri >= today) {
        return false
    } else {
      
        return true
    }
}
//------------------- 事前説明会申込処理へ
const shosai = (i) => { 

  // 申込内容配列の初期化
  moshikomi_pg = {}
  
  // 受付〆切日を過ぎた場合
  if(end_flg == true){

    message.value = shakyo_name+"社会福祉協議会の申込み受付は終了しました。"
    message_cat.value = 0;
    message_flag.value = true;
    message_method.value = "read_error";
    contentMessage.value = MessageModal
    return
  }


  if(login_status.value == false){
      message.value = "事前説明会の申込みにはログインが必要です。"
      message_cat.value = 0;
      message_flag.value = true;
      message_method.value = "read_error";
      contentMessage.value = MessageModal
      return

  }

  let syurui = program[i+st.value-1].syurui

  if(syurui == 3){
    // 種類が動画視聴の時
    let sanka_flg = 0
    // 締切前に事前説明会の申込み状況を確認
    for(let u = 0;u<user_jizen_jyokyo.length;u++){
      if(user_jizen_jyokyo[u].jokyo != 9){
          if(program[i+st.value-1].jizen_id == user_jizen_jyokyo[u].jizen_id){
            sanka_flg = 1
          }
        }
      }

      // 申込済みなら詳細ページへの進入不可
      if(sanka_flg == 1){
          message.value = "この事前説明会は申込済です。"
          message_cat.value = 0;
          message_flag.value = true;
          message_method.value = "read_error";
          contentMessage.value = MessageModal

      }else{
          moshikomi_pg = program[i+st.value-1]
          message.value ="この事前説明会を申込みますか？\n※申込済みの事前説明会がある場合、そちらはキャンセルされます。";
          message_cat.value = 1;
          message_flag.value = true;
          message_method.value = "jisseki_add";
          contentMessage.value = MessageModal          
      }

  }else{

    // 種類が動画視聴の以外の時

      // 定員の確認
      let teiin = program[i+st.value-1].teiin
      let jisseki_count = program[i+st.value-1].jisseki_count
      if( jisseki_count >= teiin){
        message.value = "この事前説明会は満員です。"
        message_cat.value = 0;
        message_flag.value = true;
        message_method.value = "read_error";
        contentMessage.value = MessageModal
        return
      }
      
      // 締切の確認
      let shimekiri = new Date(program[i+st.value-1].shimekiri_date +" 23:59:59")
      let today = new Date()

      if ((program[i+st.value-1].shimekiri_date == "" || program[i+st.value-1].shimekiri_date == null) || (shimekiri >= today)) {

        let sanka_flg = 0
        // 締切前に事前説明会の申込み状況を確認
        for(let u = 0;u<user_jizen_jyokyo.length;u++){
          if(user_jizen_jyokyo[u].jokyo != 9){
            if(program[i+st.value-1].jizen_id == user_jizen_jyokyo[u].jizen_id){
              sanka_flg = 1
            }
          }
        }

        // 申込済みなら詳細ページへの進入不可
        if(sanka_flg == 1){
            message.value = "この事前説明会は申込済です。"
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "read_error";
            contentMessage.value = MessageModal

        }else{
          moshikomi_pg = program[i+st.value-1]
          message.value ="この事前説明会を申込みますか？\n※申込済みの事前説明会がある場合、そちらはキャンセルされます。";
          message_cat.value = 1;
          message_flag.value = true;
          message_method.value = "jisseki_add";
          contentMessage.value = MessageModal
          
        }

      }
    }
    
  
}

// お知らせへ移動
let move_notification = function(){
  
  router.push('/'+cityname+'/Taiken/notification') 
}

// 所属社協へ移動する
const move_shozoku = () =>{
    location.href=location.protocol+'//'+location.host+"/"+GlobalData.shakyo_code+"/Taiken"
}


    // メッセージを表示するウィンドウでOKを押された時
    let OK_message = function(){ 
        Close_message();//メッセージを表示するウィンドウを閉じる
     

        // message_methodの内容に応じてこちら（親コンポーネント）の関数を起動する
        if(message_method.value == "jisseki_add"){

          // キャンセルする事前説明会が存在するかどうか
          let cancel_jizen_id = 0
          if(user_jizen_jyokyo.length != 0){
            
            // 締切前に事前説明会の申込み状況を確認
            for(let u = 0;u<user_jizen_jyokyo.length;u++){

                if(cancel_jizen_id != "") cancel_jizen_id += ","
                cancel_jizen_id += user_jizen_jyokyo[u].program_id
            }
          }

            // 追加処理へ(事前説明会)
            emit('call',{cmd:'toroku_jizen',moshikomi_pg:moshikomi_pg,user_id:GlobalData.user_id,cancel_jizen_id:cancel_jizen_id});
        }
    }

    // メッセージを表示するウィンドウを閉じる
    let Close_message = function(){
        message_flag.value = false;
        contentMessage.value = null
    }


//------------------- Googlemap（外部リンク）へ
const googlemap = (set_jusho) => { window.open("http://local.google.co.jp/maps?q="+set_jusho,"_blank") }

const dist = (e) => {
    alert("dist:"+e.clientX+","+e.clientY+" left,bottom:"+drg.value.left+","+drg.value.clientTop)
}
  
const home = () => {
    router.push('/'+cityname+'/Taiken')
}

const return_program = () => {
  router.push('/'+cityname+'/Taiken/Program')

}

const login = function() {
   router.replace('/'+cityname+'/Taiken/login')
}

const user_signin = () => {
    router.replace('/'+cityname+'/Taiken/user_signin' )
}
/* 初期処理 */

// 表示件数を取得
if(program.length != 0){
  kensu.value = program[0].all_count
  /*
  for(let i=0;i<program.length;i++){
 //   alert(JSON.stringify(program[i]))
 
      let today = new Date()


      let shimekiri = new Date(program[i+st.value-1].shimekiri_date +" 23:59:59")
    
      if (shimekiri >= today || program[i+st.value-1].shimekiri_date == "" || program[i+st.value-1].shimekiri_date == null) {
        kensu.value++
      }
  }
//  kensu.value = program[0].all_count
*/
}


let user_jizen_jyokyo = []//ユーザーの事前説明会申込状況を取得
if (GlobalData.$User_email) { // ログインしているかチェック
    if (GlobalData.user_id) { // ユーザー情報があるかチェック
            
        // ログイン中かつユーザー情報登録済みであればこのユーザーの事前説明会の実績データを取得
        axios.post(GlobalData.$API_URL + "Taikenuser_Jisseki",
        {
           taikenuser_id: GlobalData.user_id,
           program_kbn:2
        },GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
        .then(response => {
          if(response.data["status"] == 1){
            alert("エラーが発生しました。\n"+response.data["message"])
          }else{
              user_jizen_jyokyo = response.data.jisseki
          }
        }).catch(error => {
          
        })
      }
    }else{
      login_status.value = false
    }




    let manual_open = function(){
      let url = "https://zest-newsprint-e3e.notion.site/161c0be34f8f80f39e72c100d2514db6"
      window.open(url,"_blank")
  }

  // ユーザー切替え画面の表示
  const multipleusers_change = () =>{
      emit('call', { cmd:'multipleprofile_switch',id:GlobalData.user_id})
  }

  // Q&Aを開く
  const qanda_open = () =>{

    let url = "https://zest-newsprint-e3e.notion.site/Q-A-175c0be34f8f801998fac72f169fb66b"
    window.open(url,"_blank")
  }        
          
    
</script>
<style scoped>
.hov {
  background-color: white;
  cursor: default;
}
.hov:hover {
  background-color:royalblue;
  cursor: pointer;

}
.hov_over,.hov_over:hover{
  display:none
}

.list_bunrui {
  font-size: 14px;
}
#jizen_list tr td b div{
    width: 75px;
    float: left;
}

.program_naiyo{
  width:90%;
  margin-left:10px
}
@media screen and (min-width: 961px) {

/* PC版 */

  .sp_button_area{
      display: none
  }
}
@media screen and (max-width: 960px) {

  /* スマホ版 */

  .sp_button_area{
      display: flex
  }
}
</style>
